import { initialState } from './reducer';

export interface ISubscriptionStore {}

export function getInitialSubscriptionStore(): ISubscriptionStore {
  return { ...initialState };
}
